import React from 'react'
import { connect } from 'react-redux'
import {
  Fade,
} from '@material-ui/core'

import { PHCont } from './styled'
import { 
  StdCard,
  CommentRow
} from 'components'

const CommentHistory = props => {
  const { pouDetail } = props
  return (
    <Fade in={true} timeout={1000}>
      <PHCont>
        <StdCard title="Comment History" style={{ flex: 1, marginTop:'1rem'}}>
          {Object.keys(pouDetail).length>0 &&
            pouDetail.comments.map((item, i) => {
              let files = pouDetail.attachments.filter(x=>x.commentId===item.id)
              return <CommentRow data={item} files={files} />
            })}
        </StdCard>
      </PHCont>
    </Fade>
  )
}

const mapStateToProps = state => {
  return {
    pouDetail : state.poUpdate.pouDetail.data
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CommentHistory)
